// import React, { useState } from "react";
// import {
//   Tabs,
//   Tab,
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Grid,
//   IconButton,
//   Tooltip,
// } from "@mui/material";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import LauncherImage from "../assets/linqhaul.png";
// import trackingImage from "../assets/hivetronics.png";
// import cortexBetaImage from "../assets/Cortex-beta.png";
// import cortexImage from "../assets/cortex.png";
// import irisImage from "../assets/iris.png";
// import irisBetaImage from "../assets/iris-beta.png";
// import pulseImage from "../assets/pulse.png";
// import visionImage from "../assets/Vision.png";
// import rakeMandiImage from "../assets/rakemandi.png";

// const environments = ["Production", "Staging"];

// const urls = {
//   Production: {
//     Cortex: "cortex.linqhaul.com",
//     "Cortex Beta": "cortex.beta.linqhaul.com",
//     "Cortex Console": "cortex.console.linqhaul.com",
//     Iris: "iris.linqhaul.com",
//     "Iris Beta": "iris.beta.linqhaul.com",
//     "Iris Console": "iris.console.linqhaul.com",
//     "Rake Mandi": "rakemandi.linqhaul.com",
//     Tracking: "web.hivetronics.ai",
//     Vision: "vision.linqhaul.com",
//     Pulse: "pulse.linqhaul.com",
//     IOG: "lh-iog.web.app",
//   },
//   Staging: {
//     Cortex: "cortex.linqhaul.dev",
//     "Cortex Console": "cortex.console.linqhaul.dev",
//     Iris: "iris.linqhaul.dev",
//     "Iris Console": "iris.console.linqhaul.dev",
//     "Rake Mandi": "rakemandi.linqhaul.dev",
//     Vision: "vision.linqhaul.dev",
//     Pulse: "pulse.linqhaul.dev",
//     IOG: "lh-iog-stage.web.app",
//   },
// };

// // Logos for services
// const logos = {
//   Iris: irisImage,
//   Cortex: cortexImage,
//   "Cortex Console": LauncherImage,
//   "Iris Console": LauncherImage,
//   "Cortex Beta": cortexBetaImage,
//   "Iris Beta": irisBetaImage,
//   "Rake Mandi": rakeMandiImage,
//   Vision: visionImage,
//   Pulse: pulseImage,
//   Tracking: trackingImage,
//   IOG: LauncherImage,
// };

// export default function EnvTabs() {
//   const [value, setValue] = useState(0);
//   const [copied, setCopied] = useState(null);

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   const handleCardClick = (link) => {
//     window.open(`https://${link}`, "_blank");
//   };

//   const handleCopy = (link) => {
//     navigator.clipboard.writeText(link);
//     setCopied(link);
//     setTimeout(() => setCopied(null), 2000);
//   };

//   return (
//     <Box sx={{ width: "100%", typography: "body1", marginTop: "5px" }}>
//       {/* Tabs Navigation */}
//       <Box
//         sx={{
//           borderBottom: 1,
//           borderColor: "divider",
//           display: "flex",
//           justifyContent: "center",
//           borderRadius: "8px",
//         }}
//       >
//         <Tabs
//           value={value}
//           onChange={handleChange}
//           aria-label="environment tabs"
//           textColor="inherit"
//           TabIndicatorProps={{
//             style: {
//               backgroundColor:
//                 value === environments.indexOf("Production")
//                   ? "#006A63"
//                   : "#25293f99",
//             },
//           }}
//           sx={{
//             width: "100%",
//             "& .MuiTabs-indicator": {
//               backgroundColor:
//                 value === environments.indexOf("Production")
//                   ? "#006A63"
//                   : "#25293f99",
//             },
//           }}
//         >
//           {environments.map((env, index) => (
//             <Tab
//               key={env}
//               label={env}
//               sx={{
//                 fontSize: "1rem",
//                 fontWeight: "bold",
//                 textTransform: "capitalize",
//                 color:
//                   value === index
//                     ? env === "Production"
//                       ? "#006A63"
//                       : "#25293F"
//                     : "#9E9E9E",
//                 width: "100%",
//                 display: "flex",
//                 justifyContent: "center",
//                 textAlign: "center",
//                 "@media (max-width:600px)": {
//                   width: "50%",
//                 },
//               }}
//             />
//           ))}
//         </Tabs>
//       </Box>

//       {/* Tabs Content */}
//       {environments.map((env, index) => (
//         <div key={env} role="tabpanel" hidden={value !== index}>
//           {value === index && (
//             <Box
//               sx={{
//                 p: 3,
//                 padding: "8px",
//                 minHeight: "calc(100vh - 64px)",
//                 backgroundColor: env === "Production" ? "#F4FBF9" : "#f2f4ff",
//               }}
//             >
//               <Grid
//                 container
//                 spacing={1}
//                 sx={{
//                   "& .MuiGrid-item": { paddingLeft: "8px", paddingTop: "8px" },
//                 }}
//               >
//                 {Object.entries(urls[env]).map(([name, link]) => (
//                   <Grid item xs={12} sm={12} md={6} lg={4} key={name}>
//                     <Card
//                       sx={{
//                         p: 2,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "space-between",
//                         cursor: "pointer",
//                         border: "1px solid #DBF0F0",

//                         borderRadius: "8px",
//                         padding: "8px 12px 8px 12px",
//                         boxShadow: "none",
//                         userSelect: "none",
//                         WebkitUserSelect: "none",
//                         WebkitTapHighlightColor: "transparent",
//                       }}
//                       onClick={() => handleCardClick(link)}
//                     >
//                       {/* Left Side: Logo */}
//                       {logos[name] && (
//                         <Box
//                           sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             width: 60,
//                             height: 60,
//                           }}
//                         >
//                           <img
//                             src={logos[name]}
//                             alt={`${name} logo`}
//                             style={{
//                               width: "100%",
//                               height: "100%",
//                               objectFit: "contain",
//                               borderRadius: "10px",
//                             }}
//                           />
//                         </Box>
//                       )}

//                       {/* Right Side: Name and URL */}
//                       <CardContent
//                         sx={{
//                           flexGrow: 1,
//                           display: "flex",
//                           flexDirection: "column",
//                           justifyContent: "center",
//                           alignItems: "flex-start",
//                           padding: "4px 0px 0px 8px;",
//                         }}
//                       >
//                         <Typography
//                           variant="h6"
//                           sx={{
//                             fontWeight: "bold",
//                             marginBottom: 0,
//                             color: "#000000de",
//                             fontSize: "1em",
//                             lineHeight: 1,
//                             opacity: 69,
//                           }}
//                         >
//                           {name}
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{
//                             wordBreak: "break-word",
//                             color: "#0000009c",
//                             fontSize: "1rem;",
//                             opacity: 54,
//                           }}
//                         >
//                           {link}
//                         </Typography>
//                       </CardContent>

//                       {/* Copy Button */}
//                       <Tooltip
//                         title={copied === link ? "Copied!" : "Copy URL"}
//                         arrow
//                         placement="top"
//                       >
//                         <IconButton
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleCopy(link);
//                           }}
//                           sx={{
//                             color: copied === link ? "#2e7d32" : "#616161",
//                           }}
//                         >
//                           <ContentCopyIcon />
//                         </IconButton>
//                       </Tooltip>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Box>
//           )}
//         </div>
//       ))}
//     </Box>
//   );

import React, { useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import LauncherImage from "../assets/linqhaul.png";
import trackingImage from "../assets/hivetronics.png";
import cortexBetaImage from "../assets/Cortex-beta.png";
import cortexImage from "../assets/cortex.png";
import irisImage from "../assets/iris.png";
import irisBetaImage from "../assets/iris-beta.png";
import pulseImage from "../assets/pulse.png";
import visionImage from "../assets/Vision.png";
import rakeMandiImage from "../assets/rakemandi.png";

/*
|--------------------------------------------------------------------------
| Environments
|--------------------------------------------------------------------------
*/

const environments = ["Production", "Staging"];

/*
|--------------------------------------------------------------------------
| Project URLs
|--------------------------------------------------------------------------
|
| Every project supports:
|
| url          -> Primary URL
| alternateUrl -> Optional alternate URL
| group        -> Group displayed in the UI
|
*/

const urls = {
  Production: {
    /*
    |--------------------------------------------------------------------------
    | Cortex
    |--------------------------------------------------------------------------
    */

    Cortex: {
      url: "cortex.linqhaul.com",
      group: "Cortex",
    },

    "Cortex Beta": {
      url: "cortex.beta.linqhaul.com",
      alternateUrl: "linqhaul-beta.web.app",
      group: "Cortex",
    },

    "Cortex Console": {
      url: "cortex.console.linqhaul.com",
      alternateUrl: "linqhaul-console.web.app",
      group: "Cortex",
    },

    /*
    |--------------------------------------------------------------------------
    | Iris
    |--------------------------------------------------------------------------
    */

    Iris: {
      url: "iris.linqhaul.com",
      alternateUrl:"linqhaul-v2.web.app",
      group: "Iris",
    },

    "Iris Beta": {
      url: "iris.beta.linqhaul.com",
      alternateUrl:"linqhaul-v2-beta.web.app",
      group: "Iris",
    },

    "Iris Console": {
      url: "iris.console.linqhaul.com",
      alternateUrl:"linqhaul-console-v2.web.app",
      group: "Iris",
    },

    /*
    |--------------------------------------------------------------------------
    | Other
    |--------------------------------------------------------------------------
    */

    "Rake Mandi": {
      url: "rakemandi.linqhaul.com",
      group: "Other",
    },

    Tracking: {
      url: "web.hivetronics.ai",
      group: "Other",
    },

    Vision: {
      url: "vision.linqhaul.com",
      group: "Other",
    },

    Pulse: {
      url: "pulse.linqhaul.com",
      group: "Other",
    },

    IOG: {
      url: "lh-iog.web.app",
      group: "Other",
    },
  },

  /*
  |--------------------------------------------------------------------------
  | Staging
  |--------------------------------------------------------------------------
  */

  Staging: {
    /*
    |--------------------------------------------------------------------------
    | Cortex
    |--------------------------------------------------------------------------
    */

    Cortex: {
      url: "cortex.linqhaul.dev",
      alternateUrl:"linqhaul-stage.web.app",
      group: "Cortex",
    },

    "Cortex Console": {
      url: "cortex.console.linqhaul.dev",
      alternateUrl:"linqhaul-console-stage.web.app",
      group: "Cortex",
    },

    /*
    |--------------------------------------------------------------------------
    | Iris
    |--------------------------------------------------------------------------
    */

    Iris: {
      url: "iris.linqhaul.dev",
      alternateUrl:"linqhaul-v2-stage.web.app",
      group: "Iris",
    },

    "Iris Console": {
      url: "iris.console.linqhaul.dev",
      alternateUrl:"linqhaul-v2-console-stage.web.app",
      group: "Iris",
    },

    /*
    |--------------------------------------------------------------------------
    | Other
    |--------------------------------------------------------------------------
    */

    "Rake Mandi": {
      url: "rakemandi.linqhaul.dev",
      group: "Other",
    },

    Vision: {
      url: "vision.linqhaul.dev",
      group: "Other",
    },

    Pulse: {
      url: "pulse.linqhaul.dev",
      group: "Other",
    },

    IOG: {
      url: "lh-iog-stage.web.app",
      group: "Other",
    },
  },
};

/*
|--------------------------------------------------------------------------
| Logos
|--------------------------------------------------------------------------
*/

const logos = {
  Iris: irisImage,

  Cortex: cortexImage,

  "Cortex Console": LauncherImage,

  "Iris Console": LauncherImage,

  "Cortex Beta": cortexBetaImage,

  "Iris Beta": irisBetaImage,

  "Rake Mandi": rakeMandiImage,

  Vision: visionImage,

  Pulse: pulseImage,

  Tracking: trackingImage,

  IOG: LauncherImage,
};

/*
|--------------------------------------------------------------------------
| Group order
|--------------------------------------------------------------------------
|
| This controls the order in which groups appear.
|
*/

const groupOrder = [
  "Cortex",
  "Iris",
  "Other",
];

/*
|--------------------------------------------------------------------------
| Component
|--------------------------------------------------------------------------
*/

export default function EnvTabs() {
  const [value, setValue] = useState(0);

  const [copied, setCopied] = useState(null);

  /*
  |--------------------------------------------------------------------------
  | Tab Change
  |--------------------------------------------------------------------------
  */

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /*
  |--------------------------------------------------------------------------
  | Get Full URL
  |--------------------------------------------------------------------------
  */

  const getFullUrl = (url) => {
    if (!url) {
      return "";
    }

    if (
      url.startsWith("http://") ||
      url.startsWith("https://")
    ) {
      return url;
    }

    return `https://${url}`;
  };

  /*
  |--------------------------------------------------------------------------
  | Get Display URL
  |--------------------------------------------------------------------------
  */

  const getDisplayUrl = (url) => {
    if (!url) {
      return "";
    }

    return url.replace(/^https?:\/\//, "");
  };

  /*
  |--------------------------------------------------------------------------
  | Open URL
  |--------------------------------------------------------------------------
  */

  const handleOpen = (url) => {
    if (!url) {
      return;
    }

    window.open(
      getFullUrl(url),
      "_blank",
      "noopener,noreferrer"
    );
  };

  /*
  |--------------------------------------------------------------------------
  | Copy URL
  |--------------------------------------------------------------------------
  */

  const handleCopy = async (event, url) => {
    event.stopPropagation();

    if (!url) {
      return;
    }

    try {
      await navigator.clipboard.writeText(
        getFullUrl(url)
      );

      setCopied(url);

      setTimeout(() => {
        setCopied(null);
      }, 2000);
    } catch (error) {
      console.error(
        "Unable to copy URL:",
        error
      );
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Group Projects
  |--------------------------------------------------------------------------
  */

  const groupProjects = (projects) => {
    const groups = {};

    Object.entries(projects).forEach(
      ([name, project]) => {
        const group =
          project.group || "Other";

        if (!groups[group]) {
          groups[group] = [];
        }

        groups[group].push({
          name,
          ...project,
        });
      }
    );

    return groups;
  };

  /*
  |--------------------------------------------------------------------------
  | Render Project Card
  |--------------------------------------------------------------------------
  */

  const renderProjectCard = (project) => {
    const {
      name,
      url,
      alternateUrl,
    } = project;

    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={4}
        key={name}
      >
        <Card
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

            cursor: "pointer",

            border:
              "1px solid #DBF0F0",

            borderRadius: "8px",

            padding:
              "8px 12px",

            boxShadow: "none",

            userSelect: "none",

            WebkitUserSelect:
              "none",

            WebkitTapHighlightColor:
              "transparent",

            transition:
              "all 0.2s ease",

            "&:hover": {
              boxShadow:
                "0 2px 8px rgba(0, 0, 0, 0.08)",

              transform:
                "translateY(-1px)",
            },
          }}
          onClick={() =>
            handleOpen(url)
          }
        >
          {/* ======================================================
              Logo
          ======================================================= */}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              width: 60,
              height: 60,

              flexShrink: 0,
            }}
          >
            {logos[name] && (
              <img
                src={logos[name]}
                alt={`${name} logo`}
                style={{
                  width: "100%",
                  height: "100%",

                  objectFit:
                    "contain",

                  borderRadius:
                    "10px",
                }}
              />
            )}
          </Box>

          {/* ======================================================
              Project Details
          ======================================================= */}

          <CardContent
            sx={{
              flexGrow: 1,

              minWidth: 0,

              display: "flex",

              flexDirection:
                "column",

              justifyContent:
                "center",

              alignItems:
                "flex-start",

              padding:
                "4px 0 4px 8px !important",
            }}
          >
            {/* ==================================================
                Project Name
            =================================================== */}

            <Typography
              variant="h6"
              sx={{
                fontWeight:
                  "bold",

                color:
                  "#000000de",

                fontSize:
                  "1rem",

                lineHeight:
                  1.3,

                marginBottom:
                  "2px",
              }}
            >
              {name}
            </Typography>

            {/* ==================================================
                Primary URL
            =================================================== */}

            <Box
              sx={{
                display:
                  "flex",

                alignItems:
                  "center",

                width:
                  "100%",

                minWidth:
                  0,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  wordBreak:
                    "break-word",

                  overflow:
                    "hidden",

                  textOverflow:
                    "ellipsis",

                  color:
                    "#0000009c",

                  fontSize:
                    "0.9rem",

                  lineHeight:
                    1.4,

                  cursor:
                    "pointer",
                }}
                onClick={(event) => {
                  event.stopPropagation();

                  handleOpen(url);
                }}
              >
                {getDisplayUrl(url)}
              </Typography>

              <Tooltip
                title={
                  copied === url
                    ? "Copied!"
                    : "Copy URL"
                }
                arrow
                placement="top"
              >
                <IconButton
                  size="small"
                  aria-label={`Copy ${name} URL`}
                  onClick={(event) =>
                    handleCopy(
                      event,
                      url
                    )
                  }
                  sx={{
                    padding:
                      "2px",

                    marginLeft:
                      "2px",

                    color:
                      copied === url
                        ? "#616161"
                        : "#616161",

                    flexShrink:
                      0,
                  }}
                >
                  <ContentCopyIcon
                    sx={{
                      fontSize:
                        16,
                    }}
                  />
                </IconButton>
              </Tooltip>
            </Box>

            {/* ==================================================
                Alternate URL
            =================================================== */}

            {alternateUrl && (
              <Box
                sx={{
                  display:
                    "flex",

                  alignItems:
                    "center",

                  width:
                    "100%",

                  minWidth:
                    0,

                  marginTop:
                    "1px",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    wordBreak:
                      "break-word",

                    overflow:
                      "hidden",

                    textOverflow:
                      "ellipsis",

                    color:
                      "#616161",

                    fontSize:
                      "0.85rem",

                    lineHeight:
                      1.4,

                    cursor:
                      "pointer",

                    "&:hover": {
                      textDecoration:
                        "none",
                    },
                  }}
                  onClick={(event) => {
                    event.stopPropagation();

                    handleOpen(
                      alternateUrl
                    );
                  }}
                >
                  {getDisplayUrl(
                    alternateUrl
                  )}
                </Typography>

                <Tooltip
                  title={
                    copied ===
                    alternateUrl
                      ? "Copied!"
                      : "Copy alternate URL"
                  }
                  arrow
                  placement="top"
                >
                  <IconButton
                    size="small"
                    aria-label={`Copy alternate URL for ${name}`}
                    onClick={(event) =>
                      handleCopy(
                        event,
                        alternateUrl
                      )
                    }
                    sx={{
                      padding:
                        "2px",

                      marginLeft:
                        "2px",

                      color:
                        copied ===
                        alternateUrl
                          ? "#2e7d32"
                          : "#616161",

                      flexShrink:
                        0,
                    }}
                  >
                    <ContentCopyIcon
                      sx={{
                        fontSize:
                          16,
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
          </CardContent>
        </Card>
      </Grid>
    );
  };

  /*
  |--------------------------------------------------------------------------
  | Render Group
  |--------------------------------------------------------------------------
  */

  const renderGroup = (
    groupName,
    projects
  ) => {
    return (
      <Box
        key={groupName}
        sx={{
          mb: 2,
        }}
      >
        {/* ======================================================
            Group Header
        ======================================================= */}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",

            gap: 1,

            px: 1,

            mb: 0.5,

            mt: 1,
          }}
        >
          <Typography
            sx={{
              fontSize:
                "1rem",

              fontWeight:
                700,

              color:
                "#25293F",

              whiteSpace:
                "nowrap",
            }}
          >
            {groupName}
          </Typography>

          <Box
            sx={{
              flex: 1,

              height:
                "1px",

              backgroundColor:
                "#D5E5E3",
            }}
          />
        </Box>

        {/* ======================================================
            Group Projects
        ======================================================= */}

        <Grid
          container
          spacing={1}
        >
          {projects.map(
            renderProjectCard
          )}
        </Grid>
      </Box>
    );
  };

  /*
  |--------------------------------------------------------------------------
  | Main JSX
  |--------------------------------------------------------------------------
  */

  return (
    <Box
      sx={{
        width: "100%",
        typography: "body1",
        marginTop: "5px",
      }}
    >
      {/* ========================================================
          Tabs Navigation
      ========================================================= */}

      <Box
        sx={{
          borderBottom: 1,

          borderColor:
            "divider",

          display: "flex",

          justifyContent:
            "center",

          borderRadius:
            "8px",
        }}
      >
        <Tabs
          value={value}
          onChange={
            handleChange
          }
          aria-label="environment tabs"
          textColor="inherit"
          sx={{
            width: "100%",

            "& .MuiTabs-indicator":
              {
                backgroundColor:
                  value === 0
                    ? "#006A63"
                    : "#25293f99",
              },
          }}
        >
          {environments.map(
            (env, index) => (
              <Tab
                key={env}
                label={env}
                sx={{
                  fontSize:
                    "1rem",

                  fontWeight:
                    "bold",

                  textTransform:
                    "capitalize",

                  color:
                    value ===
                    index
                      ? env ===
                        "Production"
                        ? "#006A63"
                        : "#25293F"
                      : "#9E9E9E",

                  width:
                    "100%",

                  display:
                    "flex",

                  justifyContent:
                    "center",

                  textAlign:
                    "center",

                  "@media (max-width:600px)":
                    {
                      width:
                        "50%",
                    },
                }}
              />
            )
          )}
        </Tabs>
      </Box>

      {/* ========================================================
          Tab Content
      ========================================================= */}

      {environments.map(
        (env, index) => {
          if (value !== index) {
            return (
              <div
                key={env}
                role="tabpanel"
                hidden
              />
            );
          }

          const groupedProjects =
            groupProjects(
              urls[env]
            );

          return (
            <Box
              key={env}
              role="tabpanel"
              sx={{
                p: 1,

                minHeight:
                  "calc(100vh - 64px)",

                backgroundColor:
                  env ===
                  "Production"
                    ? "#F4FBF9"
                    : "#f2f4ff",
              }}
            >
              {/* ==================================================
                  Groups
              =================================================== */}

              {groupOrder.map(
                (groupName) => {
                  const projects =
                    groupedProjects[
                      groupName
                    ];

                  if (
                    !projects ||
                    projects.length ===
                      0
                  ) {
                    return null;
                  }

                  return renderGroup(
                    groupName,
                    projects
                  );
                }
              )}
            </Box>
          );
        }
      )}
    </Box>
  );
}